import { Button } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";

/** Brand-colored button: colors come from the --brand-* CSS variables injected by Wrapper */
var BrandButtonView = function BrandButtonView(props) {
  var _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'primary' : _props$variant,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      className = props.className,
      disabled = props.disabled,
      children = props.children,
      startIcon = props.startIcon,
      onClick = props.onClick;
  var variantClassName = {
    primary: 'bg-[var(--brand-primary)] text-white shadow-[0_10px_30px_-12px_var(--brand-primary)] hover:brightness-110',
    outline: 'border border-[var(--brand-primary)]/25 bg-white/70 text-[var(--brand-primary)] hover:bg-[var(--brand-primary)]/5',
    ghost: 'bg-white/10 text-white backdrop-blur hover:bg-white/20',
    ghostOutline: 'border border-white/30 bg-transparent text-white hover:bg-white/10'
  }[variant];
  return /*#__PURE__*/_jsx(Button, {
    disableElevation: true,
    type: type,
    disabled: disabled,
    startIcon: startIcon,
    onClick: onClick,
    className: clsx('rounded-full font-semibold normal-case transition-all duration-300 hover:-translate-y-0.5', size === 'large' ? 'px-8 py-3.5 text-base' : 'px-6 py-2.5 text-sm', variantClassName, className),
    children: children
  });
};

export default BrandButtonView;